// extracted by mini-css-extract-plugin
export default {"card":"CardPomo_card__5O+6e","active":"CardPomo_active__FXPSB","header_card":"CardPomo_header_card__C-S2i","card_bottom":"CardPomo_card_bottom__HXvCD"};